import useKeyBinder, { KeyEnum } from 'app/hooks/useKeyBinder';
import { last } from 'lodash';
import { ReactNode, useEffect, useState } from 'react';
import { PopupManagerContext } from './context';
import { PopupWithId } from './Popup/type';

export class PopupStore {
  static popups: PopupWithId[] = [];
  static register(popup: PopupWithId) {
    PopupStore.popups = [...PopupStore.popups, popup];
  }

  static unregister(id: string) {
    PopupStore.popups = PopupStore.popups.filter((p) => p.id !== id);
  }
  static closeTop() {
    const popup = last(PopupStore.popups);
    if (popup) {
      if (popup?.api.close()) {
        PopupStore.unregister(popup.id);
      }
    }
  }
}

function useOnMouseUp(handle: (e: MouseEvent) => void, deps: any[] = []) {
  useEffect(() => {
    window.addEventListener('mouseup', handle);
    return () => window.removeEventListener('mouseup', handle);
  }, deps);
}

export default function PopupManager() {
  useKeyBinder(PopupStore.closeTop, KeyEnum.ESCAPE);

  useOnMouseUp((e: MouseEvent) => {
    const popup = last(PopupStore.popups);
    const target = e.target as HTMLElement;
    if (popup) {
      const PopupElement = target.closest(`#popup-${popup.id}`);
      const clickOutside = !PopupElement;
      const clickOnAnchor = popup.api.anchor?.contains(target);

      if (clickOutside && !clickOnAnchor && popup.api.backdrop) {
        PopupStore.closeTop();
      }
    }
  }, []);

  return <></>;
}
